// Reactive keys - synced to/from instance properties via autorun
export const REACTIVE_KEYS = {
  accessToken: 'spotify_token',
  authRedirectUrl: 'spotify_auth_redirect_url',
  email: 'spotify_email',
  refreshToken: 'spotify_refresh_token'
} as const

// OAuth-only keys - temporary values, not instance properties
export const OAUTH_KEYS = {
  codeVerifier: 'spotify_code_verifier',
  state: 'spotify_auth_state'
} as const

const KEYS = { ...REACTIVE_KEYS, ...OAUTH_KEYS } as const

type KeyValues = (typeof KEYS)[keyof typeof KEYS]

export function getItem(key: KeyValues) {
  return localStorage.getItem(key) ?? undefined
}

export function setItem(key: KeyValues, value: string) {
  return localStorage.setItem(key, value)
}

export function removeItem(key: KeyValues) {
  return localStorage.removeItem(key)
}
